export const notify = {
  success: (vm, message) =>
    vm.$buefy.toast.open({ message, type: "is-success", queue: false }),
  error: (vm, message = "A aparut o eroare. Incercati din nou.") =>
    vm.$buefy.toast.open({ message, type: "is-danger", queue: false }),
};
